import {HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {inject} from '@angular/core';
import {ApiAuthenticateResponseModel} from '../model/api-authenticate-response.model';
import {AdminService} from '../service/admin.service';

/**
 * @constant
 * @description This constant provides an interceptor to handle administrator API authentication JWT injection into HTTP requests.
 * @export
 * @interceptor
 * @name AdministratorApiAuthenticationInterceptorFn
 * @param {HttpRequest<any>} httpRequest The HTTP request to intercept.
 * @param {HttpHandlerFn} next The next handler in the chain.
 * @returns {Observable<HttpEvent<any>>} The observable of the HTTP event.
 */
export const AdministratorApiAuthenticationInterceptorFn: HttpInterceptorFn = (httpRequest: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {

  // Ensure we're not working with an administrator route, if so execute the next handler in the chain.
  if (!httpRequest.url.match(/^(https?:\/\/.*)?\/api\/administrator\/?.*?$/gis)) return next(httpRequest);

  // Ensure we need credentials, if not execute the next handler in the chain.
  if (!httpRequest.withCredentials) return next(httpRequest);

  // Localize our employee service.
  const administratorService: AdminService = inject(AdminService);

  // Retrieve the session token from the session storage.
  const session: ApiAuthenticateResponseModel = administratorService.session();

  // Reset the request object to include the session token.
  const newHttpRequest: HttpRequest<any> = httpRequest.clone({setHeaders: {Authorization: `Bearer ${session.token}`}});

  // We're done, execute the next handler in the chain.
  return next(newHttpRequest);
};
